/**
 * business-logic-model-web-oberflaeche, Abschnitt "Navigation & Routing":
 * `NoteResponse.targetUrl` liefert absichtlich einen API-Pfad, keine
 * Frontend-Route -- diese reine String-Transformation übersetzt ihn, bevor
 * React Router ihn als Navigationsziel verwendet. Unbekannte Muster (z.B.
 * ein künftiger API-Pfad) fallen auf das Dashboard zurück, statt eine
 * ungültige Route zu erzeugen.
 */
const PATTERNS: ReadonlyArray<{ readonly regex: RegExp; readonly to: (match: RegExpMatchArray) => string }> = [
  { regex: /^\/api\/sources\/([^/]+)$/, to: (m) => `/sources/${m[1]}` },
  { regex: /^\/api\/models\/([^/]+)\/review-context$/, to: (m) => `/models/${m[1]}/review` },
  { regex: /^\/api\/changes\/([^/]+)$/, to: (m) => `/changes/${m[1]}` },
  { regex: /^\/api\/matrix$/, to: () => '/matrix' },
  { regex: /^\/api\/dashboard$/, to: () => '/' },
];

export function translateNoteTargetUrl(apiTargetUrl: string): string {
  for (const pattern of PATTERNS) {
    const match = apiTargetUrl.match(pattern.regex);
    if (match) {
      return pattern.to(match);
    }
  }
  return '/';
}
